<template>
  <div style="width: 100%; margin: 30px 0">
    <div style="width: fit-content; margin: auto">
      <span class="loader"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoadingSpinner',
}
</script>

<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: #1f2124;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
